import {getId} from 'apis/model/base'
import _ from 'lodash'
import {ROOT_URL} from "../envs/_current/config";

const getLinkToDetail = (item) => {
    const type = _.get(item, '_type')
    const idname = _.get(item, 'idname')
    if (_.isEmpty(type)) {
        return '/'
    }
    let searchParams = new URLSearchParams()
    switch (type) {
        case 'user':
            return '/user/' + (idname ? idname : _.get(item, 'username'))
        case 'poll_question':
            return '/news/poll_question/' + (idname ? idname : _.get(item, 'id'))
        case 'ask':
            return '/news/ask/' + (idname ? idname : _.get(item, 'id'))
        case 'post':
            return '/news/post/' + (idname ? idname : _.get(item, 'id'))
        case 'article':
            return '/news/article/' + (idname ? idname : _.get(item, 'id'))
        case 'organization_announcement':
            return '/news/o-announcement/' + (idname ? idname : _.get(item, 'id'))
        case 'course_class_announcement':
            return '/news/c-announcement/' + (idname ? idname : _.get(item, 'id'))
        case 'keyword':
            return '/t/' + (idname ? idname : _.get(item, 'id'))
        case 'category':
            return '/category/' + idname
        case 'document':
            return '/docs/' + (idname ? idname : _.get(item, 'id'))
        case 'product':
            return '/product/' + (idname ? idname : _.get(item, 'id'))
        case 'catholic_household':
            return '/catholic-household-book/' + (idname ? idname : _.get(item, 'id'))
        case 'channel':
            if (
                [
                    'organization', 'user'
                    // 'organization'
                ].includes(
                    _.get(item, 'owner._type', '')
                )
            ) {
                return '/channel/' + (idname ? idname : _.get(item, 'id'))
            }

            return getLinkToDetail(
                _.get(item, 'owner')
            )
        case 'organization':
            return '/organization/' + (idname ? idname : _.get(item, 'id'))
        case 'organization_department':
            return '/group/' + (idname ? idname : _.get(item, 'id'))
        case 'examination':
            return '/examination/' + (idname ? idname : _.get(item, 'id'))
        case 'examination_paper':
            return '/examination-paper/' + (idname ? idname : _.get(item, 'id'))
        case 'god_word':
            return '/wog/' + (idname ? idname : _.get(item, 'id'))
        case 'codi_document':
            return '/book/' + (idname ? idname : _.get(item, 'id'))
        case 'codi_document_row':
            const codi_id = getId(item?.codi_document ?? item?.owner)
            if (codi_id) {
                const row_id = item?.id
                searchParams.set('row', row_id)
                return {
                    hash: '#' + row_id,
                    pathname: '/book/' + codi_id,
                    search: row_id ? '?' + searchParams.toString() : undefined,
                }
            }
            break;
        case 'course':
            return '/course/' + (idname ? idname : _.get(item, 'id'))
        case 'course_class':
            return '/classroom/' + _.get(item, 'id')
        case 'music':
            return '/song/' + (idname ? idname : _.get(item, 'id'))
        case 'missal':
            return '/missal/' + (idname ? idname : _.get(item, 'id'))
        case 'missal_version':
            return '/missal-version/' + _.get(item, 'id')
        case 'course_class_exam':
            return '/course-class-exam/' + _.get(item, 'id')
        case 'course_class_exam_attempt':
            return '/course-class-exam-attempt/' + _.get(item, 'id')
        case 'dictionary':
            return ''
        case 'feed':
            return getLinkToDetail(_.get(item, 'content'))
        default:
            return (
                '/' + _.get(item, '_type') + '/' + (idname ? idname : _.get(item, 'id'))
            )
    }
}

export const getAbsoluteLinkToDetail = (item) => {
    const path = getLinkToDetail(item);
    return ROOT_URL + path;
}

export default getLinkToDetail
